
import React from "react";
import Header from "../Header";
import Footer from "../Footer";
import "./About.css";

const ABOUT_IMAGE = "/about-artist.png";

export default function About({ navigateTo }) {
  return (
    <>
      <Header navigateTo={navigateTo} />

      <main className="about-page">
        <section className="about-hero">
          <div className="about-hero-content">
            <span className="about-eyebrow">درباره نقش خیال</span>

            <h1>
              جایی که هنر و اصالت به نقش تبدیل می‌شود
            </h1>

            <p>
              نقشِ خیال مجموعه‌ای هنری است که با عشق به هنرهای اصیل ایرانی
              شکل گرفته؛ جایی برای خلق آثاری دست‌ساز، منحصربه‌فرد و ماندگار.
            </p>

            <div className="about-hero-actions">
              <button
                type="button"
                className="about-primary-btn"
                onClick={() => navigateTo("shop")}
              >
                مشاهده محصولات ←
              </button>

              <button
                type="button"
                className="about-secondary-btn"
                onClick={() => navigateTo("blog-list")}
              >
                 مجله نقش خیال
              </button>
            </div>
          </div>

          <div className="about-hero-image">
            <img
              src={ABOUT_IMAGE}
              alt="دست‌های هنرمند در حال نقاشی روی سفال در کارگاه نقش خیال"
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          </div>
        </section>

        <section className="about-section about-story-section">
          <div className="about-story-card">
            <span className="about-section-tag">روایت ما</span>

            <h2>به نقشِ خیال خوش آمدید</h2>

            <p>
              به «نقشِ خیال» خوش آمدید؛ جایی که هنر، اصالت و خلاقیت در کنار
              یکدیگر معنا پیدا می‌کنند.
            </p>

            <p>
              نقشِ خیال مجموعه‌ای هنری است که با عشق به هنرهای اصیل ایرانی
              شکل گرفته؛ جایی برای خلق آثاری دست‌ساز، منحصربه‌فرد و ماندگار
              که هر کدام روایتی از رنگ، نقش و خیال را در خود دارند.
            </p>

            <p>
              در این مجموعه، هر اثر با دقت، ظرافت و توجه به جزئیات خلق می‌شود
              تا علاوه بر زیبایی بصری، حامل بخشی از فرهنگ، هنر و هویت ایرانی
              باشد.
            </p>
          </div>
        </section>

        <section className="about-founder-section">
          <div className="about-founder-card">
            <div className="founder-intro">
              <span className="about-section-tag">بنیان‌گذار</span>

              <h2>پریسا عبداله پور؛ بنیان‌گذار نقشِ خیال</h2>

              <p>
                من پریسا عبداله پور هستم، بنیان‌گذار نقشِ خیال. فعالیت هنری خود را از سال
                ۱۳۹۵ با فراگیری هنر تذهیب و تشعیر آغاز کردم و از همان سال، با
                حضور در نمایشگاه‌های مختلف، آثارم را به علاقه‌مندان هنر ارائه
                دادم.
              </p>

              <p>
                در سال ۱۳۹۶ نیز با ورود به هنر نقطه‌کوبی، مسیر تازه‌ای را تجربه
                کردم و آثارم را در نمایشگاه‌های پردیس به نمایش گذاشتم.
              </p>

              <p>
                علاقه به یادگیری، تجربه و خلق آثار هنری، مسیر من را به سمت
                میناکاری روی سفال، کاشی هفت‌رنگ و در ادامه نقاشی زیرلعاب و
                رولعاب هدایت کرد. از سال ۱۳۹۷ تاکنون، به‌صورت حرفه‌ای در این
                حوزه‌ها فعالیت داشته‌ام.
              </p>
            </div>

            <div className="founder-signature-box">
              <span>باور نقش خیال</span>
              <blockquote>
                «هر نقش، داستانی برای گفتن دارد و هر رنگ، احساسی برای منتقل
                کردن.»
              </blockquote>
            </div>
          </div>
        </section>

        <section className="about-timeline-section">
          <div className="about-section-heading">
            <span className="about-section-tag">مسیر هنری</span>
            <h2>از آموزش تا خلق آثار ماندگار</h2>
            <p>
              نقشِ خیال حاصل سال‌ها آموزش، تجربه، حضور در رویدادها و نمایشگاه‌های
              هنری و عشق به هنرهای ایرانی است.
            </p>
          </div>

          <div className="about-timeline">
            <div className="timeline-item">
              <div className="timeline-year">۱۳۹۵</div>
              <div className="timeline-content">
                <h3>آغاز مسیر با تذهیب و تشعیر</h3>
                <p>
                  شروع فعالیت هنری با فراگیری هنرهای تذهیب و تشعیر و حضور در
                  نمایشگاه‌های مختلف.
                </p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-year">۱۳۹۶</div>
              <div className="timeline-content">
                <h3>ورود به هنر نقطه‌کوبی</h3>
                <p>
                  تجربه هنر نقطه‌کوبی و ارائه آثار در نمایشگاه‌های پردیس.
                </p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-year">۱۳۹۷ تاکنون</div>
              <div className="timeline-content">
                <h3>فعالیت حرفه‌ای در هنرهای سفال و لعاب</h3>
                <p>
                  فعالیت حرفه‌ای در میناکاری روی سفال، کاشی هفت‌رنگ، نقاشی
                  زیرلعاب و رولعاب.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="about-values-section">
          <div className="about-section-heading">
            <span className="about-section-tag">ارزش‌های نقش خیال</span>
            <h2>آنچه در هر اثر جریان دارد</h2>
          </div>

          <div className="about-values-grid">
            <div className="about-value-card">
              <span>🎨</span>
              <h3>اصالت هنر ایرانی</h3>
              <p>
                الهام از ریشه‌های هنر ایرانی و تلاش برای حفظ روح، رنگ و هویت
                آن در آثار معاصر.
              </p>
            </div>

            <div className="about-value-card">
              <span>🖌️</span>
              <h3>ظرافت و جزئیات</h3>
              <p>
                توجه به جزئیات، ترکیب رنگ‌ها و اجرای دقیق نقش‌ها در هر اثر
                دست‌ساز.
              </p>
            </div>

            <div className="about-value-card">
              <span>🏺</span>
              <h3>آثار منحصربه‌فرد</h3>
              <p>
                خلق آثاری خاص و ماندگار که هر کدام شخصیت، داستان و حس خود را
                دارند.
              </p>
            </div>

            <div className="about-value-card">
              <span>✨</span>
              <h3>روایت رنگ و خیال</h3>
              <p>
                تبدیل نقش‌ها، رنگ‌ها و خیال‌ها به آثاری که بتوانند با دل مخاطب
                ارتباط برقرار کنند.
              </p>
            </div>
          </div>
        </section>

        <section className="about-final-section">
          <div className="about-final-card">
            <h2>هدف نقشِ خیال</h2>
            <p>
              هدف من از خلق نقشِ خیال، ارائه آثاری خاص و ماندگار است؛ آثاری که
              بتوانند زیبایی هنر دست و ارزش هنر ایرانی را به فضای زندگی و دل
              مخاطبان هدیه دهند.
            </p>

            <button
              type="button"
              className="about-primary-btn"
              onClick={() => navigateTo("shop")}
            >
               محصولات نقش خیال ←
            </button>
          </div>
        </section>
      </main>

      <Footer navigateTo={navigateTo} />
    </>
  );
}